export default "__VITE_ASSET__deUejUvm__"